import React, { useState } from "react";
import { storage } from "../firebase"; // Import Firebase storage
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; // Import
import { MdCloudUpload } from "react-icons/md";
import ThumbnailUpload from "./ThumbnailUpload";
import { useNavigate } from "react-router-dom";
// import {
//   syncImageUrls,
//   getStorageUrls,
//   updateArtistImageURL,
// } from "../functions/syncImages";

const ImageUpload = () => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isThumbnailUploadVisible, setIsThumbnailUploadVisible] =
    useState(true);

  // Get an item from sessionStorage

  const isImageFile = (file) => {
    const allowedExtensions = ["jpg", "jpeg", "png", "gif"];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    return allowedExtensions.includes(fileExtension);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    console.log("File is", file);
    if (file && isImageFile(file)) {
      setSelectedFile(file);
      //uploadImage();
    } else {
      setSelectedFile(null);
      alert("Please select a valid image file (jpg, jpeg, png, gif).");
    }
  };

  const uploadImage = async () => {
    if (!selectedFile) {
      alert("Please select an image before uploading.");
      return;
    }
    //artist stored in local storage
    const artist = localStorage.getItem("fullName");

    if (artist === null) {
      alert("Please Register or Sign In");
      return;
    }
    setIsUploading(true);
    setIsThumbnailUploadVisible(true);
    const storageRef = ref(
      storage,
      `images/${artist}/${artist}_${selectedFile.name}`
    );

    try {
      await uploadBytes(storageRef, selectedFile);
      console.log("File uploaded successfully.");
      const docId = sessionStorage.getItem("docId");
    } catch (error) {
      alert("There was an error in uploading the file, please try again.");
    } finally {
      setIsUploading(false);
      //setIsThumbnailUploadVisible(true);
      //setImageUrls(urls);
      navigate("/Gallery"); // Replace with the actual path to your "ImageUpload" route
    }
  };

  return (
    <>
      <div>
        {!isUploading && isThumbnailUploadVisible && (
          <form
            id='upload-form'
            className='image-container-dk mb-4'
            onClick={() => document.querySelector(".input-field").click()}>
            <input
              type='file'
              className='input-field'
              hidden
              id='customFile'
              accept='.jpg, .jpeg, .png, .gif'
              onChange={handleFileChange}
              //onChange={uploadImage}
            />

            <MdCloudUpload color='1475cf' size={"100"} align='center' />
            <p>Click to select your file!</p>
            <p>We accept .jpg, .jpeg, .png files no larger than 2MB</p>
          </form>
        )}

        {isThumbnailUploadVisible && selectedFile && (
          <ThumbnailUpload
            selectedFile={selectedFile}
            isUploading={isUploading}
            uploadImage={uploadImage}
          />
        )}
      </div>
    </>
  );
};

export default ImageUpload;
